import { Chip, IconButton, Tooltip } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { TFunction } from 'i18next';

import { CURRENT_STEP_COLORS, STATUS_COLORS } from 'constants/transactions';

export const renderCellStatus = (
  translate: TFunction
): ((p: GridRenderCellParams) => React.ReactElement) => {
  const CellStatus = (p: GridRenderCellParams): React.ReactElement => {
    if (!p.value) {
      return <></>;
    }

    const value = p.value.toLowerCase();
    const label = translate(`transaction.status.${value}`);
    return <Chip label={label} size="small" color={STATUS_COLORS[value]} />;
  };

  CellStatus.displayName = 'CellStatus';

  return CellStatus;
};

export const renderCellCurrentStep = (
  translate: TFunction
): ((p: GridRenderCellParams) => React.ReactElement) => {
  const CellStatus = (p: GridRenderCellParams): React.ReactElement => {
    if (!p.value) {
      return <></>;
    }
    const { value } = p;

    const label = translate(`transaction.currentStep.${value}`);
    return (
      <Chip
        label={label}
        size="small"
        color={CURRENT_STEP_COLORS[value]}
        variant="outlined"
      />
    );
  };

  CellStatus.displayName = 'CellCurrentStep';

  return CellStatus;
};

export const renderCellExternalLinks = (
  translate: TFunction
): ((p: GridRenderCellParams) => React.ReactElement) => {
  const CellLinkUrl = (params: GridRenderCellParams): React.ReactElement => {
    const realEstateUrl = `/real-estates/${params.row.property.id}`;
    // eslint-disable-next-line max-len
    const investorUrl = `${process.env.REACT_APP_HUBSPOT_CONTACT_BY_EMAIL_URL}${params.row['user.email']}`;

    const handleOpenRealEstateLink = () => {
      window.open(realEstateUrl, '_blank')?.focus();
    };

    const handleOpenInvestorLink = () => {
      window.open(investorUrl, '_blank')?.focus();
    };

    return (
      <>
        <Tooltip title={translate('transaction.realEstateLink').toString()}>
          <IconButton
            aria-label="link"
            color="inherit"
            onClick={handleOpenRealEstateLink}
            size="small"
          >
            <HomeOutlinedIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title={translate('transaction.investorLink').toString()}>
          <IconButton
            aria-label="link"
            color="inherit"
            onClick={handleOpenInvestorLink}
            size="small"
          >
            <AccountBoxOutlinedIcon />
          </IconButton>
        </Tooltip>
      </>
    );
  };

  CellLinkUrl.displayName = 'CellCellLinkUrl';

  return CellLinkUrl;
};
